import "./login.css";
import Logo1 from "../../assets/icons/logo1";
import Logo from "../../assets/icons/logo";
import Input from "antd/lib/input";
import UserIcon from "../../assets/icons/userIcon";
import PasswordIcon from "../../assets/icons/passwordIcon";
import Button from "antd/lib/button";
import { Link, useNavigate } from "react-router-dom";
import { SiApple } from "react-icons/si";
import FacebookIcon from "../../assets/icons/facebookIcon";
import GoogleIcon from "../../assets/icons/googleIcon";
import useAuth from "../../hooks/use_auth";
import { useEffect } from "react";
import version from "../../constant/version.json";
import Env from "../../constant/env.json";

const Login = () => {
  const navigate = useNavigate();

  const { loginController, loadings } = useAuth();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="login">
      {/* login_container */}
      <div className="login_container">
        <div className="logo">
          <Logo1 />
        </div>
        {/* logo_mobile */}
        <div className="logo_mobile">
          <Logo />
        </div>
        {/* tabs_container */}
        <div className="tabs_container">
          <div className={"avtive_tab"}>Login</div>
          <div
            onClick={() => {
              navigate("/signup");
            }}
          >
            Sign Up
          </div>
        </div>
        {/* login_form */}
        <form onSubmit={loginController.handleSubmit} className="login_form">
          {/* email */}
          <div className="name">
            <Input
              value={loginController.values.email}
              onChange={loginController.handleChange}
              name="email"
              id="email"
              autoFocus
              placeholder="Email"
              status={
                loginController.touched.email && loginController.errors.email
                  ? "error"
                  : ""
              }
              disabled={
                loadings.checkEmail ||
                loadings.login ||
                loadings.handleGetCaptcha
              }
            />
            <UserIcon />
          </div>
          {/* password */}
          <div className="password">
            <Input.Password
              id="password"
              name="password"
              value={loginController.values.password}
              onChange={loginController.handleChange}
              status={
                loginController.touched.password &&
                loginController.errors.password
                  ? "error"
                  : ""
              }
              disabled={
                loadings.checkEmail ||
                loadings.login ||
                loadings.handleGetCaptcha
              }
              placeholder="Password"
            />
            <PasswordIcon />
          </div>
          {/* forgot password */}
          <div
            className="forgot_password_link"
            onClick={() => {
              navigate("/reset_password");
            }}
          >
            Forgot your password?
          </div>
          {/* submit button */}
          <Button
            loading={
              loadings.checkEmail || loadings.login || loadings.handleGetCaptcha
            }
            htmlType="submit"
            className="login_btn"
          >
            <span> Login</span>
          </Button>
          {/* other login options */}
          <div className="other_options">
            {/* <div className="other_options_title">
              <div className="divider"></div>
              <div>Other Login Options</div>
              <div className="divider"></div>
            </div>
            <div className="social_media_login">
              <Link href={""}>
                <FacebookIcon />
              </Link>

              <Link href={""}>
                <GoogleIcon />
              </Link>
              <Link href={""}>
                <SiApple />
              </Link>
            </div> */}
            <span>
              version {version.version}
              {Env.base_url == "https://devapi.naranel.com/api/" ? (
                <span
                  className="font-medium"
                  style={{ fontStyle: "italic", marginLeft: 8 }}
                >
                  (development)
                </span>
              ) : null}
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Login;
